import React from "react";
import styled from "styled-components";
import Flex from "../Flex/Flex";
import { Typography } from "../Typography";

const Wrapper = styled(Flex)`
    &:hover {
        border-color: ${({ theme }) => theme.v2.colors["surface-1200"]};
    }
`;

export type BaseMenuItemProps = {
    active: boolean;
    elementId: string;
    title: string;
    handleItemClick: () => void;
    leading?: React.ReactNode;
    trailing?: React.ReactNode;
};

export const BaseMenuItem = ({ active, elementId, title, handleItemClick, leading, trailing }: BaseMenuItemProps) => {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        handleItemClick();
    };

    return (
        <Wrapper
            as="li"
            borderColor={active ? "surface-1200" : "primary-100"}
            borderStyle="solid"
            borderWidth="0 0 0 1px"
            key={elementId}
            px={8}
            py={4}
            gap={4}
        >
            {leading}
            <Typography
                as="a"
                color={active ? "primary-1200" : "primary-700"}
                href={elementId}
                onClick={handleClick}
                variant={active ? "label-x-small-medium" : "label-x-small-regular"}
            >
                {title}
            </Typography>
            {trailing}
        </Wrapper>
    );
};
